<template>
  <v-btn
      :disabled="disabled"
      :loading="loading"
      :variant="variant"
      size="x-small"
      color="primary"
      @click="$emit('action')"
  >
    <slot name="prepend-icon">
      <v-icon
          v-if="prependIcon"
          class="mr-0"
          left
          size="small"
      >
        {{prependIcon}}
      </v-icon>
    </slot>
    <slot>
    </slot>
    <slot name="append-icon">
      <v-icon
          v-if="appendIcon"
          class="ml-0"
          right
          size="small"
      >
        {{appendIcon}}
      </v-icon>
    </slot>
    <template v-slot:loader>
      <v-progress-circular indeterminate size="12" width="2"/>
    </template>
  </v-btn>
</template>

<script>
export default {
  name: "ActionButton",
  props: {
    disabled: {default: false, type: Boolean},
    prependIcon: {required: false, type: String},
    appendIcon: {required: false, type: String},
    loading: {default: false, type: Boolean},
    variant: {default: 'flat', type: String}
  },
};
</script>

<style scoped>

</style>
